<template>
  <div class="index">
    <Music :active="isMusic" @click="onclick" />
    <a class="home-btn" href="http://www.0531yun.com/ksh.html" target="_blank">
      <img :src="require('@/assets/home.png')" alt="">
    </a>
    <CustomPano ref="pano" />
    <CustomTabBar />
  </div>
</template>

<script>
import CustomPano from "@/components/krpano";
import CustomTabBar from "@/components/CustomTabBar";
import Music from '@/components/Music'
export default {
  name: "HOME",
  components: {
    CustomPano,
    CustomTabBar,
    Music
  },
  data() {
    return {
      isMusic: true
    };
  },
  mounted() {
    this.$store.commit('set_istab', true)
  },
  methods: {
    onclick() {
      this.isMusic = !this.isMusic
      this.$refs.pano.krpano.call('pausesoundtoggle(bg)')
    }
  }
};
</script>

<style lang="scss" scoped>
.index {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
}

.home-btn{
  position: fixed;
  right:20px;
  top: 60px;
  z-index: 99;
  img{
    width: 30px;
    height: 30px;
  }
}
</style>
